import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '@/i18n/labels';

/**
 * 404 Not Found page.
 */
export const NotFoundPage: React.FC = () => {
  const { t } = useT();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#0f172a',
        color: '#fff',
      }}
    >
      <h1 style={{ fontSize: 72, margin: 0, color: '#3b82f6' }}>404</h1>
      <p style={{ fontSize: 18, color: '#94a3b8', marginBottom: 24 }}>{t('notFoundTitle')}</p>
      <Link
        to="/"
        style={{
          padding: '10px 20px',
          backgroundColor: '#3b82f6',
          color: '#fff',
          borderRadius: 4,
          textDecoration: 'none',
          fontSize: 14,
          fontWeight: 600,
        }}
      >
        {t('notFoundBack')}
      </Link>
    </div>
  );
};
